import { j as n } from "../jsx-runtime-Wav_3Wde.js";
import { s as d } from "../index.esm-DOxVcNnO.js";
import { forwardRef as u } from "react";
import { styled as c, css as x } from "styled-components";
import { compose as f, space as b, layout as h } from "styled-system";
import { Flex as j, Box as g } from "../Flexbox/Flexbox.mjs";
import "../Icon/StyledPath.mjs";
import "../LoadingSpinner/components.mjs";
import w from "../LoadingSpinner/LoadingSpinnerBranded.mjs";
import "react-dom";
const C = [
  "textSize",
  "variant"
], k = /* @__PURE__ */ c.button.withConfig({
  shouldForwardProp: (o) => !C.includes(o) && d(o)
}).withConfig({
  componentId: "sc-e78b8ce2-0"
})([
  "",
  ""
], ({ theme: o, variant: r, textSize: t }) => /* @__PURE__ */ x([
  "",
  " ",
  " ",
  " ",
  ""
], o.components.button.base, o.components.button[r], o.components.button[t], f(b, h))), S = /* @__PURE__ */ c.span.withConfig({
  componentId: "sc-e78b8ce2-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.button.iconWrapper), v = /* @__PURE__ */ u(({ type: o = "button", variant: r = "action", textSize: t = "medium", onClick: l, disabled: i = !1, loading: e = !1, children: p, Icon: s, ...a }, m) => /* @__PURE__ */ n.jsx(k, {
  ref: m,
  type: o,
  variant: r,
  textSize: t,
  onClick: i ? void 0 : l,
  disabled: i,
  ...a,
  children: /* @__PURE__ */ n.jsxs(n.Fragment, {
    children: [
      !e && p,
      s && [
        "textLink",
        "secondaryLink"
      ].includes(r) && !e && /* @__PURE__ */ n.jsx(S, {
        children: /* @__PURE__ */ n.jsx(s, {
          "data-qa-id": "text-link-icon",
          color: "currentColor",
          size: [
            "1.8rem",
            null,
            "2.2rem"
          ]
        })
      }),
      e && /* @__PURE__ */ n.jsx(j, {
        children: /* @__PURE__ */ n.jsx(g, {
          flexGrow: 1,
          children: /* @__PURE__ */ n.jsx(w, {
            Icon: null,
            circleSize: [
              "21px",
              "23px"
            ],
            circleThickness: "2px",
            backgroundColor: "global.transparent",
            color: "currentColor",
            "data-qa-id": "loading-spinner",
            "aria-label": "Loading Spinner"
          })
        })
      })
    ]
  })
}));
export {
  k as StyledButton,
  v as default
};
